import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { FORM_URL } from 'app/@common/constants'


export default function SelectCityFrom({ ...props }) {

    const myProps = {
        urlAjax: FORM_URL.PACKAGES_CITY,
        placeholder: 'Select city from',
        icon: { icon: 'city' },
        isMulti: false,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}